import { EmailRegisterSubmitInfo } from '@yaotai/components';
import { AxiosInstance } from 'axios';

const getLoginServices = ({
  RbacGateWayInstance,
  LoginGateWayInstance,
}: {
  RbacGateWayInstance: AxiosInstance;
  LoginGateWayInstance: AxiosInstance;
}) => {
  return {
    postActivateRegister(data: EmailRegisterSubmitInfo) {
      return RbacGateWayInstance.post('/activate_register', data);
    },
    postActivate(data: EmailRegisterSubmitInfo) {
      return RbacGateWayInstance.post('/activate', data);
    },
    getRsaKey() {
      return RbacGateWayInstance.get('/rsa_key');
    },
    postServerLogin(data: EmailRegisterSubmitInfo) {
      return RbacGateWayInstance.post('/server_login', data);
    },
    getLoginMsgCode(data: any) {
      return LoginGateWayInstance.post(`/login/phone_code`, data);
    },
    postMobileLogin(data: any) {
      return RbacGateWayInstance.post(`/mobile_login`, data);
    },
  };
};

export default getLoginServices;
